/* MyEbike shared countdown. Client-side ticking timer.
   Loaded globally via theme.liquid. Drives any element carrying a
   [data-mb-countdown] attribute (pre-order ship dates, sale-banner
   deadlines, etc.) so multiple, unrelated countdowns can coexist.

   Markup contract (all attributes optional except the first):
   - data-mb-countdown="2026-07-15T00:00:00"  target ISO datetime (required)
   - data-mb-countdown-label="Ships in"        text prepended before the timer
   - data-mb-countdown-done="Now shipping"      text shown once the target passes
   - [data-mb-countdown-text] child             where the text is written
                                                (falls back to the element itself)

   Output format is compact: "Xd Yh Zm Ws". Leading zero units are
   dropped (e.g. once days hit 0 the "d" segment disappears) but minutes
   and seconds always show so the timer never looks frozen.

   Cache-safe: every value is computed client-side against the visitor's
   real wall-clock time, never the Liquid render time. All writes use
   textContent, so attribute data is never interpreted as HTML. */
(function () {
  if (window.__mbCountdown) return;
  window.__mbCountdown = true;

  function format(remaining, label) {
    var totalSec = Math.floor(remaining / 1000);
    var days = Math.floor(totalSec / 86400);
    var hours = Math.floor((totalSec % 86400) / 3600);
    var mins = Math.floor((totalSec % 3600) / 60);
    var secs = totalSec % 60;

    var parts = [];
    if (days > 0) parts.push(days + 'd');
    // Show hours if we have days OR a non-zero hour count, so "2d 0h 5m 1s"
    // stays readable while "5m 1s" stays compact.
    if (days > 0 || hours > 0) parts.push(hours + 'h');
    parts.push(mins + 'm');
    parts.push(secs + 's');

    var text = parts.join(' ');
    return label ? label + ' ' + text : text;
  }

  function start(el) {
    var raw = el.getAttribute('data-mb-countdown');
    if (!raw) return;

    var target = new Date(raw);
    if (isNaN(target.getTime())) return; // invalid datetime, skip silently

    var textTarget = el.querySelector('[data-mb-countdown-text]') || el;
    var label = el.getAttribute('data-mb-countdown-label') || '';
    var doneText = el.getAttribute('data-mb-countdown-done') || '';
    var intervalId = null;

    function tick() {
      var remaining = target.getTime() - Date.now();
      if (remaining <= 0) {
        textTarget.textContent = doneText;
        if (intervalId !== null) clearInterval(intervalId);
        intervalId = null;
        return;
      }
      textTarget.textContent = format(remaining, label);
    }

    tick(); // paint immediately, do not wait a full second
    intervalId = setInterval(tick, 1000);
  }

  function init() {
    var els = document.querySelectorAll('[data-mb-countdown]');
    for (var i = 0; i < els.length; i++) {
      start(els[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
